import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { FC } from 'react';

const ReactQueryDevTools: FC = () => {
    if (process.env.NODE_ENV !== 'development') {
        return null;
    }

    return <ReactQueryDevtools position="bottom-right" initialIsOpen={false} />;
};

export default ReactQueryDevTools;
